export const iconNames = {
  "01d": "clear-d",
  "01n": "clear-n",
  "02d": "partly-cloudy-d",
  "02n": "partly-cloudy-n",
  "03d": "scattered-d",
  "03n": "scattered-n",
  "04d": "cloudy",
  "04n": "cloudy",
  "09d": "partly-cloudy-rain-d",
  "09n": "partly-cloudy-rain-n",
  "10d": "rain",
  "10n": "rain",
  "11d": "thunderstorms-d",
  "11n": "thunderstorms-n",
  "13d": "snow",
  "13n": "snow",
  "50d": "mist",
  "50n": "mist",
};
